import {
  ROUTE_AD_INSIGHTS,
  ROUTE_CUSTOM_DASHBOARD,
  ROUTE_APP_INSIGHTS,
} from './constants';

const { baseUrl } = window.conviva;

const getBaseUrl = (feature) => {
  switch (feature) {
  case ROUTE_AD_INSIGHTS: {
    return '/ad-insights';
  }
  case ROUTE_APP_INSIGHTS: {
    return '/app-insights';
  }
  case ROUTE_CUSTOM_DASHBOARD: {
    return `${baseUrl}/dashboard`;
  }
  default: {
    return `${baseUrl}`;
  }
  }
};

export default getBaseUrl;
